import { PageFeatureCards } from "../../types/Page";
import { IMAGE_URL } from "../../../path";
import "../../../styles/FeaturedSection.scss";

interface FeaturedSectionProps {
    featured_cards: PageFeatureCards[];
    background_color: string;
    background_image?: string;
    card_color: string;
    font_color: string;
    border_color: string;
    page?: string;
}

function FeaturedSection({
                             featured_cards,
                             background_color,
                             background_image,
                             card_color,
                             font_color,
                             border_color,
                             page
                         }: FeaturedSectionProps) {
    return (
        <section
            className="featured-section"
            style={{
                "--featured-background-color": background_color,
                "--featured-background-image": `url(${background_image})`,
                "--featured-card-color": card_color,
                "--featured-font-color": font_color,
                "--featured-border-color": border_color,
            } as React.CSSProperties}
        >
            <div className={`featured-section-content ${page === "about-us" ? "active" : ""}`}>
                {featured_cards.map((card) => (
                    <div
                        key={card.id}
                        className="featured-card"
                    >
                        <div className="featured-card-image">
                            <img
                                src={`${IMAGE_URL}/${card.image}`}
                                alt={card.title}
                            />

                            <span className="featured-card-image-angle" />
                        </div>

                        <div
                            className="featured-card-body"
                            style={{
                                backgroundColor: card_color,
                                color: font_color,
                            }}
                        >
                            <h2>{card.title}</h2>

                            <p>{card.body}</p>

                            {card.link && !card.icon && (
                                <div className="card-link">
                                    <a href={card.link}>Find Out More</a>
                                </div>
                            )}

                            <span className="featured-card-body-angle" />
                        </div>

                        {card.icon && (
                            <div className="featured-card-icon">
                                {page === "home" && card.link ? (
                                    <a href={card.link}>
                                        <img
                                            src={`${IMAGE_URL}/${card.icon}`}
                                            alt=""
                                        />
                                    </a>
                                ) : (
                                    <>
                                        <img
                                            src={`${IMAGE_URL}/${card.icon}`}
                                            alt=""
                                        />

                                        {card.link && (
                                            <a href={card.link}>
                                                LEARN MORE
                                            </a>
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}

export default FeaturedSection;
